<script setup lang="ts">
import LeLabel from "@dsk/components/Label/LeLabel.vue";

const props = defineProps<{
  text: string;
  label: string;
  href: string;
}>();
</script>

<template>
  <div class="le-header-promotion">
    <a :href="props.href" class="le-header-promotion__link">
      {{ props.text }}
      <LeLabel color="attention" class="le-header-promotion__label">
        {{ props.label }}
      </LeLabel>
    </a>
  </div>
</template>

<style lang="less" scoped>
@import "@dsk/styles/all";

.le-header-promotion {
  display: flex;
  align-items: center;
  height: 100%;
  font-size: 15px;

  &__link {
    display: flex;
    align-items: center;
    gap: 4px;
    margin: 0;
    padding: 8px 16px;
    color: @colors[@neutrals][100];

    &:hover {
      border-radius: 100px;
      background-color: @colors[@primary][800];
    }

    &:focus {
      border-radius: 100px;
      .focus-outline(green);
    }
  }

  &__label {
    font-size: 8px;
    font-weight: 800;
  }
}
</style>
